import React, { useRef } from 'react'
import Title from '../Components/Elements/Title';
import Text from '../Components/Elements/Text'; 
import MainContainer from '../Components/Elements/MainContainer';
import { useNavigate } from 'react-router-dom';
import { useStore } from '../Stores/store';
import { observer } from 'mobx-react-lite';
import { useEffect } from 'react';


const Thanks = observer(() => {
    const { generalStore } = useStore();
    const { hasSubmittedRSVP, isNotComing, setHasSubmittedRSVP, setIsNotComing } = generalStore;
    const navigate = useNavigate();
    const initialHasSubmittedRSVP = useRef(hasSubmittedRSVP);

    useEffect(() => {
        if (!initialHasSubmittedRSVP.current) {
            navigate('/app/rsvp');
        }
    }, [navigate]);

    const goHome = () => {
        navigate('/app');
        setHasSubmittedRSVP(false);
        setIsNotComing(false);
    }

    return (
        <MainContainer>
            <Title size="3">Thanks for your RSVP!</Title>
            {
                isNotComing ? <Text>We&apos;re sorry you can&apos;t make it!</Text> :
                <Text>We really look forward to seeing you on the big day!</Text>
            }
            <div className="flex justify-center py-4">
                <button onClick={() => goHome()} className="px-4 py-2 bg-blue-500 text-white rounded cursor-pointer font-lora hover:bg-blue-700">
                    Back to home
                </button>
            </div>
            
        </MainContainer>
    )
});

export default Thanks;